import React, { ReactElement } from 'react';
import { LoaderIcon } from 'react-hot-toast';
import { useSearchParam } from 'react-use';

import { useTranslation } from 'react-i18next';

export function IntegrationCallbackPage(): ReactElement {
  const { t } = useTranslation('containerInterface');
  const code = useSearchParam('code');
  const state = useSearchParam('state');
  const error = useSearchParam('error');

  if (window.location.host !== process.env.ROOT_APP_DOMAIN) {
    window.opener.postMessage({ code, state, error }, window.location.origin);
  }

  return (
    <div className="flex h-full min-h-screen flex-row items-center justify-center gap-2">
      <LoaderIcon className="h-4 w-4" />
      <span>{t('common:loading')}</span>
    </div>
  );
}
